import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { commonMessages } from "@saleor/intl";
import { stringify as stringifyQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../misc";
import {
  LanguageCodeEnum,
  MenuItemTranslationInput
} from "../../types/globalTypes";
import TranslationsMenuItemPage, {
  fieldNames
} from "../components/TranslationsMenuItemPage";
import { TypedUpdateMenuItemTranslations } from "../mutations";
import { TypedMenuItemTranslationDetails } from "../queries";
import { UpdateMenuItemTranslations } from "../types/UpdateMenuItemTranslations";
import {
  // languageEntitiesUrl,
  languageEntityUrl,
  TranslatableEntities
} from "../urls";

export interface TranslationsMenuItemQueryParams {
  activeField: string;
}
export interface TranslationsMenuItemProps {
  id: string;
  languageCode: LanguageCodeEnum;
  params: TranslationsMenuItemQueryParams;
}

const TranslationsMenuItem: React.FC<TranslationsMenuItemProps> = ({
  id,
  languageCode,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const onEdit = (field: string) =>
    navigate(
      "?" +
        stringifyQs({
          activeField: field
        }),
      true
    );
  const onUpdate = (data: UpdateMenuItemTranslations) => {
    if (data.menuItemTranslate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate("?", true);
    }
  };
  const onDiscard = () => {
    navigate("?", true);
  };

  return (
    <TypedMenuItemTranslationDetails variables={{ id, language: languageCode }}>
      {pageHeaderTranslations => (
        <TypedUpdateMenuItemTranslations onCompleted={onUpdate}>
          {(updateTranslations, updateTranslationsOpts) => {
            const handleSubmit = (field: string, data: string) => {
              const input: MenuItemTranslationInput = {};
              if (field === fieldNames.name) {
                input.name = data;
              } else if (field === fieldNames.url) {
                input.url = data;
              } else if (field === fieldNames.thumbnailUrl) {
                input.thumbnailUrl = data;
              } else if (field === fieldNames.mbThumbnailUrl) {
                input.mbThumbnailUrl = data;
              }
              updateTranslations({
                variables: {
                  id,
                  input,
                  language: languageCode
                }
              });
            };

            return (
              <TranslationsMenuItemPage
                activeField={params.activeField}
                disabled={
                  pageHeaderTranslations.loading ||
                  updateTranslationsOpts.loading
                }
                languageCode={languageCode}
                languages={maybe(() => shop.languages, [])}
                saveButtonState={updateTranslationsOpts.status}
                onBack={() => history.go(-1)}
                onEdit={onEdit}
                onDiscard={onDiscard}
                onLanguageChange={lang =>
                  navigate(
                    languageEntityUrl(lang, TranslatableEntities.menuItem, id)
                  )
                }
                onSubmit={handleSubmit}
                menuItem={maybe(() => pageHeaderTranslations.data.menuItem)}
              />
            );
          }}
        </TypedUpdateMenuItemTranslations>
      )}
    </TypedMenuItemTranslationDetails>
  );
};
TranslationsMenuItem.displayName = "TranslationsMenuItem";
export default TranslationsMenuItem;
